import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { isPresent } from '@ember/utils';

export default Factory.extend({
  createdAt() {
    let fakeDate;
    if (isPresent(this.fromDate) && isPresent(this.toDate)) {
      fakeDate = faker.date.between({ from: this.fromDate, to: this.toDate });
    } else {
      fakeDate = faker.date.past();
    }
    return fakeDate;
  },

  event: 'update',

  locationSetting: trait({
    items() {
      const item = faker.helpers.arrayElement([
        { type: 'agreements', field: 'sendToBcc', 'flow-name': '👩‍💼👨‍💼 Meeting', value: [true, false] },
        { type: 'flows', field: 'useExistingPhoto', 'flow-name': '👩‍💼👨‍💼 Meeting', value: [false, true] },
        { type: 'locations', field: 'color', value: ['#b8182b', '#ef3934'] },
      ]);
      return [item];
    },
  }),
});
